package com.example.ramsembedded.pages

import androidx.compose.runtime.Composable
import com.example.ramsembedded.components.layouts.PageLayout
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun HomePage() {
    PageLayout("Home") {

        Surface(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                HeaderSectionHome()
                PlacementSection()
                IndustryLeadersSection()
                FutureSection()
            }
        }
    }
}

@Composable
fun HeaderSectionHome() {
    Div(
        attrs = Modifier
            .fillMaxWidth()
            .padding(16.px)
            .toAttrs()
    ) {
        H3(
            attrs = Modifier
                .fontSize(28.px)
                .fontWeight(FontWeight.Bold)
                .textAlign(TextAlign.Center)
                .margin(bottom = 8.px)
                .toAttrs()
        ) {
            Text("Welcome to RAMS Embedded IT Solutions")
        }
        P(
            attrs = Modifier
                .fontSize(18.px)
                .fontStyle(FontStyle.Italic)
                .textAlign(TextAlign.Center)
                .toAttrs()
        ) {
            Text("Achieve Your Career Dreams with Us")
        }
    }
}

@Composable
fun PlacementSection() {
    Div(
        attrs = Modifier
            .fillMaxWidth()
            .padding(16.px)
            .styleModifier {
                background(
                    "linear-gradient(135deg, rgba(106, 17, 203, 1), rgba(37, 117, 252, 1))"
                )
            }
            .borderRadius(16.px)
            .boxShadow(
                offsetX = 4.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                color = rgba(0, 0, 0, 0.25)
            )

            .color(Colors.White)
            .padding(24.px)
            .margin { bottom(14.px) }
            .toAttrs()
    ) {
        H3(
            attrs = Modifier
                .fontSize(24.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px)
                .toAttrs()
        ) {
            Text("Exceptional Placement Rates")
        }
        P(
            attrs = Modifier
                .fontSize(16.px)
                .lineHeight(1.5)
                .toAttrs()
        ) {
            Text(
                "At RAMS Embedded IT Solutions, we are proud to offer an exceptional 99.9% placement rate, " +
                        "ensuring that your aspirations transform into reality. " +
                        "Join us to kickstart your career and unlock the doors to unparalleled success."
            )
        }
    }
}

@Composable
fun IndustryLeadersSection() {
    Div(
        attrs = Modifier
            .fillMaxWidth()
            .padding(16.px)
            .styleModifier {
                background("linear-gradient(135deg, rgba(37, 117, 252, 1), rgba(106, 17, 203, 1))")
                borderRadius(16.px)
                boxShadow(
                    offsetX = 4.px,
                    offsetY = 4.px,
                    blurRadius = 12.px,
                    color = rgba(0, 0, 0, 0.25)
                )
            }
            .margin { bottom(14.px) }
            .toAttrs()
    ) {
        H3(
            attrs = Modifier
                .fontSize(24.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px)
                .color(Colors.White) // White color for the heading text
                .toAttrs()
        ) {
            Text("Work with Top Industry Leaders")
        }
        P(
            attrs = Modifier
                .fontSize(16.px)
                .lineHeight(1.5)
                .color(Colors.White) // White color for the paragraph text
                .toAttrs()
        ) {
            Text(
                "Our alumni have secured positions in leading multinational companies like " +
                        "Mercedes-Benz, Wipro, Bosch, and many more. By choosing RAMS, you are setting the foundation to " +
                        "work alongside the best in the industry."
            )
        }
    }
}

@Composable
fun FutureSection() {
    Div(
        attrs = Modifier
            .fillMaxWidth()
            .padding(16.px)
            .styleModifier {
                background("linear-gradient(135deg, rgba(0, 204, 204, 1), rgba(0, 255, 255, 1))")
                borderRadius(16.px)
                boxShadow(
                    offsetX = 4.px,
                    offsetY = 4.px,
                    blurRadius = 12.px,
                    color = rgba(0, 0, 0, 0.25)
                )
            }
            .margin { bottom(8.px) }
            .toAttrs()
    ) {
        H3(
            attrs = Modifier
                .fontSize(24.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 8.px)
                .color(Colors.White) // White color for the heading text
                .toAttrs()
        ) {
            Text("Shape Your Future, Fulfill Your Dreams")
        }
        P(
            attrs = Modifier
                .fontSize(16.px)
                .lineHeight(1.5)
                .color(Colors.White) // White color for the paragraph text
                .toAttrs()
        ) {
            Text(
                "Your ambitions matter to us. Our tailored training programs, expert mentorship, and industry-aligned curriculum are designed to help you reach your highest potential. At RAMS, your dreams are within reach."
            )
        }
    }
}

